import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { AppendToBodyModule } from 'Angular/features/directives/append-to-body/append-to-body.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';

import { SimpleDropdownComponent } from './simple-dropdown.component';

@NgModule({
    imports: [
        AppendToBodyModule,
        CommonModule,
        DisabledModule,
        FormsModule,
        HelpModalModule,
        IconModule,
        TooltipModule,
    ],
    declarations: [SimpleDropdownComponent],
    exports: [SimpleDropdownComponent],
})
export class SimpleDropdownModule {}
